import { ErrorHandler, Injectable, inject } from '@angular/core';

import { ClientDiagnosticsService } from './client-diagnostics.service';

@Injectable()
export class DiagnosticsErrorHandler extends ErrorHandler {
  private readonly diagnostics = inject(ClientDiagnosticsService);

  override handleError(error: unknown): void {
    super.handleError(error);
    this.diagnostics.error('angular', error);
  }
}
